import { render, staticRenderFns } from "./ChooseInvestmentAmount.vue?vue&type=template&id=60902893&scoped=true"
import script from "./ChooseInvestmentAmount.vue?vue&type=script&lang=js"
export * from "./ChooseInvestmentAmount.vue?vue&type=script&lang=js"
import style0 from "./ChooseInvestmentAmount.vue?vue&type=style&index=0&id=60902893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60902893",
  null
  
)

export default component.exports